(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herdabdeckplatten-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lumberland-size-guide')) {
    customElements.define('lumberland-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.choice = { depth: '53', width: '60', wood: 'eiche' };
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.dataset.depth) this.choice.depth = button.dataset.depth;
          else if (button.dataset.wood) this.choice.wood = button.dataset.wood;
          else if (button.dataset.width) {
            this.choice.width = button.dataset.width;
            this.choice.depth = button.dataset.rowDepth;
          } else return;
          this.render();
        });
        this.querySelectorAll('[data-controls]').forEach((element) => { element.hidden = false; });
        this.classList.add('is-ready');
        this.render();
      }
      render() {
        const { depth, width, wood } = this.choice;
        const onGlass = depth === '53';
        const minimum = onGlass ? `${(Number(width) - 1.5).toLocaleString('de-DE')} × 51,5 cm` : `${width} × 59 cm`;
        this.querySelectorAll('[data-depth]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.depth === depth)));
        this.querySelectorAll('[data-wood]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.wood === wood)));
        this.querySelectorAll('[data-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.panel !== depth;
          panel.querySelectorAll('[data-row]').forEach((row) => {
            const active = row.dataset.row === width;
            row.classList.toggle('is-selected', active);
            row.querySelector('button').setAttribute('aria-pressed', String(active));
          });
        });
        const picture = this.querySelector(`template[data-picture="${wood}_${width}_${depth}"]`);
        this.querySelector('[data-image]').replaceChildren(picture.content.cloneNode(true));
        this.querySelector('[data-selection]').textContent = `${wood === 'eiche' ? 'Eiche' : 'Wildeiche'} · Platte ${width} × ${depth} cm`;
        this.querySelector('[data-measure]').textContent = minimum;
        this.querySelector('[data-measure-label]').textContent = onGlass ? 'benötigte Glasfläche mindestens' : 'benötigte freie Arbeitsfläche mindestens';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
